import React from 'react'
import Card from '../components/VenuePage/Card'
import data from '../venue_info.json'
import Title from '../components/VenuePage/Title'
import Header from '../components/SEO/Header'
import Nav from '../components/ui/Nav'
import Footer from '../components/ui/Footer'

const Hotels = () => {
    const hotels = data.filter(hotel => hotel.category === "hotels" )

  return (
    <div className='overflow-x-hidden'>
    <Header title='hotels' />
    <div className='bg-th-white min-h-screen w-screen text-th-gray overflow-hidden'>
        <Nav />
       <Title title='hotels' />
        <div>
            {
                hotels.map((hotel, i) => (
                    <Card key={i} venue={hotel} i={i} />
                ))
            }
        </div>
    
        <Footer />
    </div>
    </div>
  )
}

export default Hotels